/* eslint-disable no-undef */
// userSaga.js
import { call, put, takeEvery } from 'redux-saga/effects';
import {  checkupListErrorRequest, checkupListSuccessRequest, checkupPaymentsErrorRequest, checkupPaymentsSuccessRequest, healthRecordImageRequestError, healthRecordImageRequestSuccess, healthRecordRequestError, healthRecordRequestSuccess, packageListErrorRequest, packageListSuccessRequest, promotionsErrorRequest, promotionsSuccessRequest } from './Actions';
import axios from 'axios';
import { ALL_PACKAGES_GET, CHECKUP_PAYMENTS, CHECKUPS_HEALTH_RECORD_REQUEST, CHECKUPS_RECORD_IMAGE_OPEN, MY_CHECKUPS_GET, PROMTION_PACKAGES_GET } from './Constants';
import { Modal } from 'antd';
// import logo from '../../Images/logo.png';

function* getcheckupList() {

    try {    
        
        const patientId = localStorage.getItem('PARENT_ID');
        const url = `${process.env.REACT_APP_API_BASE_URL}/checkups?parentId=${patientId}&$sort[updatedAt]=-1`;
  
        // // Example headers - You can add more headers as per your requirement
        const headers = {
            'Api-Header-Security': process.env.REACT_APP_API_HEADER_SECURITY,
            'Content-Type': 'application/json',
            Authorization: sessionStorage.jwt,
            'x-api-version': process.env.REACT_APP_X_API_VERSION,
        };
  
        // // const data = {};  // Data you want to send with the POST request (can be empty for a simple POST)
  

        const response = yield call(axios.get, url,{ headers});

        // // Check if the response is successful
        if (response.status === 200 || response.status === 201) {
            
            // Dispatch the success action with data and message      
            yield put(checkupListSuccessRequest(response.data));
        } else {
            // Dispatch the failure action with the response message
            yield put(checkupListErrorRequest('An error occurred.'));
        }

    } catch (error) {
        
        yield put(checkupListErrorRequest('An error occurred.'));
        // throw error;
    // yield put(fetchUserFailure(error));
    }
}

function* healthrecordsGet(action) {
    try {    

        const id = action.checkupId;

        const url = `${process.env.REACT_APP_API_BASE_URL}/healthrecordsnew?checkupId=${id}`;
  
        // // Example headers - You can add more headers as per your requirement
        const headers = {
            'Api-Header-Security': process.env.REACT_APP_API_HEADER_SECURITY,
            'Content-Type': 'application/json',
            Authorization: sessionStorage.jwt,
            'x-api-version': process.env.REACT_APP_X_API_VERSION,
        };
  
        // // const data = {};  // Data you want to send with the POST request (can be empty for a simple POST)
  

        const response = yield call(axios.get, url,{ headers});

        // // Check if the response is successful
        if (response.status === 200 || response.status === 201) {
            
            // Dispatch the success action with data and message      
            yield put(healthRecordRequestSuccess(response.data));
        } else {
            // Dispatch the failure action with the response message
            yield put(healthRecordRequestError('An error occurred.'));
        }
    } catch (error) {
        
        yield put(healthRecordRequestError('An error occurred.'));
        // throw error;
    // yield put(fetchUserFailure(error));
    }
}

function* healthrecImage(action) {

    try {    
        
        const url = action.url;
  
        // // Example headers - You can add more headers as per your requirement
        const headers = {
            'Api-Header-Security': process.env.REACT_APP_API_HEADER_SECURITY,
            Authorization: sessionStorage.jwt,
            'x-api-version': process.env.REACT_APP_X_API_VERSION,
        };
        const response = yield call(axios.get, url,{ headers, responseType: 'blob'});
        if (response.status === 200 || response.status === 201) {            
            const blob = URL.createObjectURL(response.data);
            window.open(blob);  
            yield put(healthRecordImageRequestSuccess(response.data));
        } else {
            yield put(healthRecordImageRequestError('An error occurred.'));
        }

    } catch (error) {
        
        yield put(healthRecordImageRequestError('An error occurred.'));
    }

}


function* getAllPackage(action) {

    try {    
        
        const page = action.page;
        let skip;
        if (page === 1) {
            skip = 0;
        } else {
            skip = (page - 1) * 8;
        }

        const orgId = action.orgId;
        let url;
        if(orgId == 'all') {
            url = `${process.env.REACT_APP_API_BASE_URL}/packages?isActive=true&$limit=8&$skip=${skip}`;
        } else {
            url = `${process.env.REACT_APP_API_BASE_URL}/packages?isActive=true&organisationsId=${orgId}&$limit=8&$skip=${skip}`;
        }
  
        const headers = {
            'Api-Header-Security': process.env.REACT_APP_API_HEADER_SECURITY,
            'Content-Type': 'application/json',
            Authorization: sessionStorage.jwt,
            'x-api-version': process.env.REACT_APP_X_API_VERSION,
        };  

        const response = yield call(axios.get, url,{ headers});

        // // Check if the response is successful
        if (response.status === 200 || response.status === 201) {
            
            // Dispatch the success action with data and message      
            yield put(packageListSuccessRequest(response.data));
        } else {
            // Dispatch the failure action with the response message
            yield put(packageListErrorRequest('An error occurred.'));
        }

    } catch (error) {
        
        yield put(packageListErrorRequest('An error occurred.'));
        // throw error;
    // yield put(fetchUserFailure(error));
    }
}

function* paymentInitiative(action) {

    try {    
        let packages = action.payload.data.packageDetails.state.data;
        let bookingDeatil = action.payload.data.patientDetails;
        let promotion = action.payload.data.promotion;

        const urlCheckup = `${process.env.REACT_APP_API_BASE_URL}/checkups`;

        let data = { 
            status: 'Booking',
            packageId: promotion == true ? packages.packageId : packages.id,
            date: bookingDeatil.date,
            organisationsId:  packages.organisationsId,
            createdById: sessionStorage.getItem('USER_ID'),
            patientsId: bookingDeatil.patientId,
            time: bookingDeatil.time,
            platform: 'QuikDr Webapp',
            createdByOrgId: 1,
            parentId: localStorage.getItem('PARENT_ID'),
            pickupAddress: bookingDeatil.address,
            pincode: bookingDeatil.pincode,
            isParentAddress: bookingDeatil.isParentAddress,
            isSampleCollectedAtHome: !bookingDeatil.atMiciroclinic,
        };

        const headers = {
            'Api-Header-Security': process.env.REACT_APP_API_HEADER_SECURITY,
            'Content-Type': 'application/json',
            Authorization: sessionStorage.jwt,
            'x-api-version': process.env.REACT_APP_X_API_VERSION,
        };  

        let checkupData;
        const responseCheckup = yield call(axios.post, urlCheckup, data, { headers});

        if(responseCheckup.status == 200 || responseCheckup.status == 201) {

            checkupData = responseCheckup.data;
            
            let price, razorPayPrice;
            price = Number(action.payload.data.total);
            razorPayPrice = Math.ceil(price * 100);
            const date = new Date();
            date.setDate(date.getDate() + 1);

            const urlPatient = `${process.env.REACT_APP_API_BASE_URL}/patients/${bookingDeatil.patientId}`;

            const responsePatient = yield call(axios.get, urlPatient, { headers});

            let patientData;
            if(responsePatient.status == 200 || responsePatient.status == 201 ) {
                
                patientData = responsePatient.data;
                const urlRazorpay = `${process.env.REACT_APP_API_BASE_URL}/razorpay`;
                data = {
                    amount: razorPayPrice,
                    expire_by: Math.floor(new Date(date).getTime() / 1000),
                    currency: 'INR',
                    'customer[email]': patientData.primaryEmail,
                    'customer[name]': `${patientData.firstName} ${patientData.lastName}`,
                    'customer[contact]': patientData.primaryContact,
                    description: 'checkup from microclinic',
                    type: 'link',
                };
                const responseRazorpay = yield call(axios.post, urlRazorpay, data, { headers});

                let razorData;
                if(responseRazorpay.status == 200 || responseRazorpay.status == 201) {
                    
                    razorData = responseRazorpay.data;

                    const urlCheckupPayment = `${process.env.REACT_APP_API_BASE_URL}/checkuppayments`;                    

                    data = {
                        amount: price,
                        checkupId: checkupData.id,
                        date: bookingDeatil.date,
                        time: bookingDeatil.time,
                        usersId: sessionStorage.getItem('USER_ID'),
                        organisationsId: packages.organisationsId,
                        createdByOrgId: 1,
                        patientsId: bookingDeatil.patientId,
                        packageId:promotion == true ? packages.packageId : packages.id,
                        parentId: localStorage.getItem('PARENT_ID'),
                        gatewayUrl: razorData[0].short_url,
                    };
                    
                    const responseCheckout = yield call(axios.post, urlCheckupPayment, data, { headers});

                    if(responseCheckout.status == 200 || responseCheckout.status == 201) {

                        const urlCheckupRazorpay = `${process.env.REACT_APP_API_BASE_URL}/checkupsrazorpayupdater/${razorData[0].id}`;

                        const response = yield call(axios.get, urlCheckupRazorpay, { headers});

                        if(response.status == 200 || response.status == 201) {

                            yield put(checkupPaymentsSuccessRequest('success'));
                            Modal.confirm({
                                title: 'Make Payment',
                                content: 'Please make payment to confirm your checkup',
                                okText: 'Make Payment',
                                onCancel() {
                                    // Optionally, handle cancel action
                                    // window.history.back();
                                },
                                onOk() {
                                    window.open(razorData[0].short_url);
                                    // const options = {
                                    //     key: process.env.RAZORPAY_ENV_KEY,
                                    //     amount: razorPayPrice, // Ensure this is in the smallest currency unit, e.g., paise
                                    //     name: `${patientData.firstName} ${patientData.lastName}`,
                                    //     description: 'Checkup payment',
                                    //     image: logo,
                                    //     invoice_id: razorData[0].id,
                                    //     handler(response) {
                                    //         if (response) {
                                    //             axios({
                                    //                 method: 'PATCH',
                                    //                 url: `${process.env.API_BASE_URL}/checkups/${checkupData.id}`,
                                    //                 headers: {
                                    //                     'Content-Type': 'application/json',
                                    //                     Authorization: sessionStorage.jwt,
                                    //                     'api-header-security': process.env.API_HEADER_SECURITY,
                                    //                 },
                                    //                 data: {
                                    //                     status: 'Confirmed',
                                    //                     isPaymentDone: true,
                                    //                 },
                                    //             }).then(() => {
                                    //                 Modal.success({
                                    //                     title: 'Payment Successful',
                                    //                     content: 'Please complete your checkup to view health records',
                                    //                 });
                                    //             });
                                    //         }
                                    //     },
                                    //     prefill: {
                                    //         name: `${patientData.firstName} ${patientData.lastName}`,
                                    //         email: patientData.primaryEmail,
                                    //     },
                                    //     theme: {
                                    //         color: '#358fff',
                                    //     },
                                    // };
                                  
                                    // Open Razorpay payment gateway
                                    // const rzp = new Razorpay(options);
                                    // rzp.open();
                                },
                            });
                        } else {
                            yield put(checkupPaymentsErrorRequest);
                        }

                        
                    } else {
                        yield put(checkupPaymentsErrorRequest);
                    }

                } else {
                    yield put(checkupPaymentsErrorRequest);
                }

            } else {
                yield put(checkupPaymentsErrorRequest);
            }

        } else {
            yield put(checkupPaymentsErrorRequest);
        }

    } catch (error) {
        
        yield put(checkupPaymentsErrorRequest);
        // throw error;
    // yield put(fetchUserFailure(error));
    }
}

function* promotionsGet() {
    try {    

        const url = `${process.env.REACT_APP_API_BASE_URL}/packagepromotion?limit=3`;
  
        // // Example headers - You can add more headers as per your requirement
        const headers = {
            'Api-Header-Security': process.env.REACT_APP_API_HEADER_SECURITY,
            'Content-Type': 'application/json',
            Authorization: sessionStorage.jwt,
            'x-api-version': process.env.REACT_APP_X_API_VERSION,
        };
  
        // // const data = {};  // Data you want to send with the POST request (can be empty for a simple POST)
  

        const response = yield call(axios.get, url,{ headers});

        // // Check if the response is successful
        if (response.status === 200 || response.status === 201) {
            
            // Dispatch the success action with data and message      
            yield put(promotionsSuccessRequest(response.data));
        } else {
            // Dispatch the failure action with the response message
            yield put(promotionsErrorRequest('An error occurred.'));
        }
    } catch (error) {
        
        yield put(promotionsErrorRequest('An error occurred.'));
        // throw error;
    // yield put(fetchUserFailure(error));
    }
}


// Watcher Saga
export function* watchFetchCheckups() {
    yield takeEvery(MY_CHECKUPS_GET, getcheckupList);
    yield takeEvery(CHECKUPS_HEALTH_RECORD_REQUEST, healthrecordsGet);
    yield takeEvery(CHECKUPS_RECORD_IMAGE_OPEN, healthrecImage);
    yield takeEvery(ALL_PACKAGES_GET, getAllPackage);
    yield takeEvery(CHECKUP_PAYMENTS, paymentInitiative);
    yield takeEvery(PROMTION_PACKAGES_GET, promotionsGet);

}
